export default __webpack_public_path__ + "static/media/footer.4041454b.png";